<template>
  <ul class="font-family text-start">
    <li v-for="item in this.$store.state.ProspectAgentInfo.MenuProspect" :key="item.ReqCodeID"
      class="sub-menu-item text-decoration-none font-color" style="cursor: pointer;">

      <div v-if="item.ReqCodeID === 28" @click="Authentication('/Verification', '', item.ReqCodeID)">
        ยื่นตรวจสอบคุณสมบัติ
        <div class="caret"></div>
      </div>

      <!-- สมัครเป็นตัวแทนกรุงเทพประกันชีวิต -->
      <div v-else-if="item.ReqCodeID === 30" @click="RedirectOnlineAgentRegister()">
        สมัครเป็นตัวแทนกรุงเทพประกันชีวิต
        <div class="caret"></div>
      </div>
      <div v-else-if="item.ReqCodeID === 29" @click="Authentication('/SendAdditionalDoc', '', item.ReqCodeID)">
        ส่งเอกสารเพิ่มเติม(ผู้สมัคร)
        <div class="caret"></div>
      </div>

      <!-- ส่งเอกสารเพิ่มเติมผู้ค้ำประกัน 1 -->
      <div v-else-if="item.ReqCodeID === 34" @click="Authentication('/SendAdditionalDoc', '', item.ReqCodeID)">
        ส่งเอกสารเพิ่มเติมผู้ค้ำประกัน
        <div class="caret"></div>
        <br>
        <h5>{{ item.GuaName }}</h5>
      </div>
      <!-- ส่งเอกสารเพิ่มเติมผู้ค้ำประกัน 2 -->
      <div v-else-if="item.ReqCodeID === 35" @click="Authentication('/SendAdditionalDoc', '', item.ReqCodeID)">
        ส่งเอกสารเพิ่มเติมผู้ค้ำประกัน
        <div class="caret"></div>
        <br>
        <h5>{{ item.GuaName }}</h5>
      </div>

    </li>
  </ul>
</template>

<script>
import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js';

export default {
  name: "MenuMobile",
  mounted() {
    if (this.$store.state.USER_NAME == '') {
      this.$router.push('/');
    }

    let AuthorizeToken = localStorage.getItem("AuthorizeToken");
    http.get("AgencyERequest/CheckMenuProspect", {
      headers: { Authorization: `Bearer ${AuthorizeToken}` }
    }).then((res) => {
      if (res.status == 200) {
        this.$store.state.ProspectAgentInfo.MenuProspect = res.data;
      }
    });
  },
  methods: {
    Authentication(To, SUBJOB, ReqCodeID) {
      if (SUBJOB === '') {
        this.$store.state.ProspectAgentInfo.CurrentMenuProspect = ReqCodeID;
        this.$router.push(To);
      }
      else {
        // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
        let AuthorizeToken = localStorage.getItem("AuthorizeToken");
        let request = {
          AGENTCODE: [],
          SUBJOB: SUBJOB
        };
        http.post("AgencyERequest/CheckCreateJob?", request, { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((res) => {
          if (res.data !== '001' && res.data !== '002') {
            this.$router.push(To);
          }
          else {
            Swal.fire({
              icon: 'error',
              html: '<lable class="fs-4 fw-normal font-family">ไม่สามารถทำรายการนี้ได้ เนื่องจากมีการร้องของานไปแล้วก่อนหน้า</lable>',
            });

            this.$router.push("/ProspectService");
          }

        }).catch((error) => {
          Swal.fire({
            icon: 'error',
            html: '<lable class="fs-4 fw-normal font-family">เกิดข้อผิดพลาดของระบบ</lable>',
          });
          this.$router.push("/ProspectService");
        });
      }
    },
    RedirectOnlineAgentRegister() {
      let AuthorizeToken = localStorage.getItem("AuthorizeToken");

      http.get("AgencyERequest/GetOnlineAgentRegisterToken", {
        headers: { Authorization: `Bearer ${AuthorizeToken}` }
      }).then((res) => {
        if (res.status == 200) {
          const targetUrl = `${process.env.VUE_APP_URL_OAR}?auth=${res.data}`;

          window.location.replace(targetUrl);
        }
      });
    },
  },
};
</script>

<style scoped>
.font-color {
  color: #0057a8;
  text-align: initial;
}

.sub-menu-item {
  border-bottom: 1px solid #dedede;
  font-size: 22px;
  font-size: 1.375rem;
  position: relative;
  padding: 1rem 1rem;
  display: block;
}

.caret {
  background-image: url(@/assets/images/arrow-blue.svg);
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 45%;
  width: 16px;
  height: 25px;
  cursor: pointer;
  display: block;
  position: absolute;
  right: 14px;
  top: 15px;
  transition: transform 0.2s ease, -webkit-transform 0.2s ease;
}
</style>